import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, MapDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Event, NamedObject } from './Event.js';
import { EventNotificationStatus } from './EventNotificationStatus.js';
import { compileToInMemoryFilter } from './filters/InMemoryFilter.js';
import { eventNotificationsInMemoryFilterCompilers } from './filters/inMemoryFilterDefinitions.js';
import { RecordAnswerDecoder } from './members/records/RecordAnswer.js';
import { BaseOrganization } from './Organization.js';
export class EventNotification extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.periodId = '';
        this.events = [];
        this.startDate = new Date();
        this.endDate = new Date();
        this.status = EventNotificationStatus.Draft;
        this.feedbackText = null;
        this.recordAnswers = new Map();
        this.acceptedRecordAnswers = new Map();
        /**
         * User who submitted the notification
         */
        this.submittedBy = null;
        this.submittedAt = null;
        /**
         * User who created the notification
         */
        this.createdBy = null;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
    isRecordEnabled(record) {
        return true;
    }
    getRecordAnswers() {
        return this.recordAnswers;
    }
    patchRecordAnswers(patch) {
        return this.patch({
            recordAnswers: patch,
        });
    }
    doesMatchFilter(filter) {
        try {
            const compiledFilter = compileToInMemoryFilter(filter, eventNotificationsInMemoryFilterCompilers);
            return compiledFilter(this);
        }
        catch (e) {
            console.error('Error while compiling filter', e, filter);
        }
        return false;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true, defaultValue: () => uuidv4() })
], EventNotification.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EventNotification.prototype, "typeId", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 365 })
], EventNotification.prototype, "periodId", void 0);
__decorate([
    field({ decoder: BaseOrganization })
], EventNotification.prototype, "organization", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Event) })
], EventNotification.prototype, "events", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotification.prototype, "startDate", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotification.prototype, "endDate", void 0);
__decorate([
    field({ decoder: new EnumDecoder(EventNotificationStatus) })
], EventNotification.prototype, "status", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EventNotification.prototype, "feedbackText", void 0);
__decorate([
    field({ decoder: new MapDecoder(StringDecoder, RecordAnswerDecoder) })
], EventNotification.prototype, "recordAnswers", void 0);
__decorate([
    field({ decoder: new MapDecoder(StringDecoder, RecordAnswerDecoder), version: 368 })
], EventNotification.prototype, "acceptedRecordAnswers", void 0);
__decorate([
    field({ decoder: NamedObject, nullable: true })
], EventNotification.prototype, "submittedBy", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 365 })
], EventNotification.prototype, "submittedAt", void 0);
__decorate([
    field({ decoder: NamedObject, nullable: true })
], EventNotification.prototype, "createdBy", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotification.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotification.prototype, "updatedAt", void 0);
//# sourceMappingURL=EventNotification.js.map